import {
  USER_ADDRESSES_GET,
  USER_DOCUMENTS_GET,
  USER_UPDATE,
  USER_LOAD,
  USER_GET,
  USERS_GET,
  USER_PROFILE_IMAGE_GET,
  USER_WATCHLISTS_INSTRUMENTS_GET,
  USER_WATCHLISTS_GET,
  USER_MEETINGS_GET,
  USER_MEETING_TYPES_GET,
} from '../actions/types';

const initialState = {
  items: {},
  addresses: {},
  documents: {},
  profileImages: {},
  watchlistInstruments: {},
  watchlistInstrumentsMap: {},
  watchlists: {},
  meetings: {},
  meetingTypes: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_UPDATE:
    case USER_LOAD._SUCCESS:
    case USER_GET._SUCCESS: {
      const { user } = action.payload;
      if (user) {
        state.items[user.id] = user;
        return state;
      }
      return state;
    }
    case USER_ADDRESSES_GET._SUCCESS: {
      const { userId, addresses } = action.payload;
      state.addresses[userId] = addresses;
      return state;
    }
    case USER_DOCUMENTS_GET._SUCCESS: {
      const { userId, documents } = action.payload;
      state.documents[userId] = documents;
      return state;
    }
    case USER_PROFILE_IMAGE_GET._SUCCESS: {
      const { userId, profileImage } = action.payload;
      state.profileImages[userId] = profileImage;
      return state;
    }
    case USER_WATCHLISTS_INSTRUMENTS_GET._SUCCESS: {
      const { userId, watchlistInstruments } = action.payload;
      state.watchlistInstruments[userId] = watchlistInstruments;
      state.watchlistInstrumentsMap[userId] = watchlistInstruments.reduce((obj, item) => {
        if (obj[item.watchlistId]) {
          obj[item.watchlistId] = [...obj[item.watchlistId], item.instrumentId];
        } else {
          obj[item.watchlistId] = [item.instrumentId];
        }
        return obj;
      }, {});
      return state;
    }
    case USER_WATCHLISTS_GET._SUCCESS: {
      const { userId, watchlists } = action.payload;
      state.watchlists[userId] = watchlists;
      return state;
    }
    case USER_MEETINGS_GET._SUCCESS: {
      const { userMeetings, userId } = action.payload;
      state.meetings[userId] = userMeetings;
      return state;
    }
    case USER_MEETING_TYPES_GET._SUCCESS: {
      const { meetingTypes, userId } = action.payload;
      state.meetingTypes[userId] = meetingTypes;
      return state;
    }
    case USERS_GET._SUCCESS: {
      const { users } = action.payload;
      users.forEach((user) => {
        if (state.items[user.id]) {
          state.items[user.id] = { ...state.items[user.id], ...user };
        } else {
          state.items[user.id] = user;
        }
      });
      return state;
    }
    default:
      return state;
  }
};

export { reducer as users };
